module.exports = __webpack_public_path__ + "img/file-video.ee01b30a.svg";